import { useMutation } from '@apollo/client';
import ReportPaymentMutation from './ReportPaymentMutation';

const ReportPaymentConnectorApollo = ({ children }) => {
  const [reportPayment, { data, loading, error }] = useMutation(ReportPaymentMutation);

  const createReportPayment = async ({ token, operatorData }) => {
    const response = await reportPayment({
      variables: { token, operatorData },
    });

    return response;
  };

  return children({
    reportPayment: createReportPayment,
    response: data,
    loading,
    error,
  });
};

export default ReportPaymentConnectorApollo;
